<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
                  <a-form-model-item prop="oriOrderId" >
                        <span slot="label" ><a-tooltip>原任务订单ID<template slot="title">原任务订单ID</template></a-tooltip> </span>
                        <a-input v-model="form.oriOrderId"  :placeholder="$t('通用.输入.请输入')+'原任务订单ID'" />
                  </a-form-model-item>
                  <a-form-model-item prop="orderNo" >
                        <span slot="label" ><a-tooltip>原订单编号<template slot="title">原订单编号</template></a-tooltip> </span>
                        <a-input v-model="form.orderNo"  :placeholder="$t('通用.输入.请输入')+'原订单编号'" />
                  </a-form-model-item>
                  <a-form-model-item prop="taskId" >
                        <span slot="label" ><a-tooltip>任务ID<template slot="title">任务ID</template></a-tooltip> </span>
                        <a-input v-model="form.taskId"  :placeholder="$t('通用.输入.请输入')+'任务ID'" />
                  </a-form-model-item>
                  <a-form-model-item prop="taskTitle" >
                        <span slot="label" ><a-tooltip>任务标题快照<template slot="title">任务标题快照</template></a-tooltip> </span>
                        <a-input v-model="form.taskTitle" :maxLength="200" :placeholder="$t('通用.输入.请输入')+'任务标题快照'" />
                  </a-form-model-item>
                  <a-form-model-item prop="submitUserId" >
                        <span slot="label" ><a-tooltip>提交人ID<template slot="title">提交人ID</template></a-tooltip> </span>
                        <a-input v-model="form.submitUserId"  :placeholder="$t('通用.输入.请输入')+'提交人ID'" />
                  </a-form-model-item>
                  <a-form-model-item prop="userId" >
                        <span slot="label" ><a-tooltip>申请人用户ID<template slot="title">申请人用户ID</template></a-tooltip> </span>
                        <a-input v-model="form.userId"  :placeholder="$t('通用.输入.请输入')+'申请人用户ID'" />
                  </a-form-model-item>
                  <a-form-model-item prop="refundStatus" >
                        <span slot="label" ><a-tooltip>售后状态：5010-待审核 5048-退款处理中 5050-退款完成 5060-卖家拒绝 5070-售后关闭<template slot="title">售后状态：5010-待审核 5048-退款处理中 5050-退款完成 5060-卖家拒绝 5070-售后关闭</template></a-tooltip> </span>
                  </a-form-model-item>
                  <a-form-model-item prop="refundAmount" >
                        <span slot="label" ><a-tooltip>退款金额<template slot="title">退款金额</template></a-tooltip> </span>
                        <a-input v-model="form.refundAmount"  :placeholder="$t('通用.输入.请输入')+'退款金额'" />
                  </a-form-model-item>
                  <a-form-model-item prop="reason" >
                        <span slot="label" ><a-tooltip>退款原因<template slot="title">退款原因</template></a-tooltip> </span>
                        <a-input v-model="form.reason" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item prop="refundPic" >
                        <span slot="label" ><a-tooltip>退款凭证图片<template slot="title">退款凭证图片</template></a-tooltip> </span>
                        <a-input v-model="form.refundPic" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item prop="remark" >
                        <span slot="label" ><a-tooltip>售后说明<template slot="title">售后说明</template></a-tooltip> </span>
                        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item prop="refuseReason" >
                        <span slot="label" ><a-tooltip>拒绝原因<template slot="title">拒绝原因</template></a-tooltip> </span>
                        <a-input v-model="form.refuseReason" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item prop="beforeStatus" >
                        <span slot="label" ><a-tooltip>退款前订单状态<template slot="title">退款前订单状态</template></a-tooltip> </span>
                  </a-form-model-item>
                  <a-form-model-item prop="beforePayStatus" >
                        <span slot="label" ><a-tooltip>退款前支付状态<template slot="title">退款前支付状态</template></a-tooltip> </span>
                  </a-form-model-item>
                  <a-form-model-item prop="refundTime" >
                        <span slot="label" ><a-tooltip>实际退款时间<template slot="title">实际退款时间</template></a-tooltip> </span>
                        <a-date-picker style="width: 100%" v-model="form.refundTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                  </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getTaskOrderRefund, addTaskOrderRefund, updateTaskOrderRefund } from '@/api/task/taskRefund'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
                          id: null,
                          oriOrderId: null,
                          orderNo: null,
                          taskId: null,
                          taskTitle: null,
                          submitUserId: null,
                          userId: null,
                      refundStatus: 0,
                          refundAmount: null,
                          reason: null,
                          refundPic: null,
                          remark: null,
                          refuseReason: null,
                      beforeStatus: 0,
                      beforePayStatus: 0,
                          refundTime: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
                              oriOrderId: [{ required: true, message: '原任务订单ID'+this.$t('通用.文本.不能为空'), trigger: 'blur' }] 
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
                          id: null,
                          oriOrderId: null,
                          orderNo: null,
                          taskId: null,
                          taskTitle: null,
                          submitUserId: null,
                          userId: null,
                      refundStatus: 0,
                          refundAmount: null,
                          reason: null,
                          refundPic: null,
                          remark: null,
                          refuseReason: null,
                      beforeStatus: 0,
                      beforePayStatus: 0,
                          refundTime: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTaskOrderRefund({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateTaskOrderRefund(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addTaskOrderRefund(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
